import React from 'react';
import columns from './columns';
import PreviewStepBase from '../../base/PreviewStepBase';
import { ASSET_ALIAS_FIELD, useCsvPreviewDataSource } from '../../base/useCsvPreviewDataSource';

export interface CapitalNeedPreviewStepProps {
  mapping: Record<string, string>;
  csvTopLines: string[][];
}

const CapitalNeedPreviewStep: React.FC<CapitalNeedPreviewStepProps> = ({
  mapping,
  csvTopLines,
}) => {
  const columnsFields = React.useMemo(() => Object.values(columns).map((col) => col.dataField), []);

  const dataSource = useCsvPreviewDataSource(
    mapping,
    csvTopLines,
    columnsFields,
    {
      field: 'status',
      value: 'Planned',
    },
    ASSET_ALIAS_FIELD,
  );

  return (
    <PreviewStepBase
      infoText={
        <>
          Here is a preview of how your new capital needs will look like in the Capital Needs Table.
          You can go back and edit your columns if needed before submitting.
        </>
      }
      dataGridId="capital-need-data-import-preview"
      pluralText="Capital Needs"
      singularText="Capital Need"
      columns={columns}
      dataSource={dataSource}
    />
  );
};

export default React.memo(CapitalNeedPreviewStep);
